import { useEffect } from 'react';
import { Pane, Paragraph, Spinner, Text, ListIcon } from 'evergreen-ui';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import getLogs from '../../queries/logs';
import { Header, Support } from '../../components';
import { setLogs } from '../../store/logsSlice';
import { SettingsIcon } from '../../components/icons';
import { useNavigate } from 'react-router-dom';

const Logs = () => {
  const user = useSelector(state => state.authentication.user);
  const token = useSelector(state => state.authentication.token);
  const logs = useSelector(state => state.logs.logs);
  const navigate = useNavigate();
  const result = useQuery('todos', () => getLogs(token, user));
  const dispatch = useDispatch();
  useEffect(() => {
    if (result.data) {
      dispatch(setLogs(result.data));
    }
  }, [result.data, dispatch]);

  //   created_at: "2021-11-03T21:50:37.148Z"
  // id: 1
  // shiftDay: "monday"
  // shiftEndTime: "2 pm"
  // shiftStartTime: "1 am"
  // shiftWeekDay: null
  // status: "accepted"
  // timestamp: "x"
  // updated_at: "2021-1

  // 09:07:33 10:21:01 | Saturday 10/30 | 05:45 AM - 09:45 AM | ACCEPTED
  const formatTimestamp = timestamp => {
    const splitted = timestamp.split(':');
    return splitted[0] + ':' + splitted[1];
  };
  return (
    <Pane height="100%" padding={16}>
      <Header
        subTitle={user.email}
        LeftIcon={<SettingsIcon size={20} />}
        RightIcon={<ListIcon color="rgba(255, 255, 255, 0.5)" size={24} />}
        onLeftIconClick={() => navigate('/app/filters')}
        extendedLogo
      />
      <Pane display="flex" flexDirection="column" alignItems="center">
        {((result.isLoading && !result.data) || result.isRefetching) && <Spinner size={100} />}
      </Pane>
      {!!logs &&
        (logs.length ? (
          logs.map((log, i) => {
            const textColor = '#F0F0F2';
            return (
              <Pane key={log.id} padding={20}>
                <Pane display="flex" justifyContent="space-between">
                  <Paragraph color={textColor} opacity={0.75} fontSize={16}>
                    {formatTimestamp(log.timestamp)}
                  </Paragraph>
                  <Paragraph color={textColor} fontSize={16} opacity={0.3} fontWeight={700}>
                    {log.status}
                  </Paragraph>
                </Pane>
                <Pane color={textColor} marginTop={10}>
                  <Text color={textColor} fontSize={16} fontWeight={700}>
                    {log.shiftWeekDay.substring(0, 3)}{' '}
                  </Text>
                  <Text color={textColor} fontSize={16} opacity={0.75}>
                    {log.shiftDay}
                    {' | '}
                  </Text>
                  <Text color={textColor} fontSize={16} fontWeight={700}>
                    {log.shiftStartTime}
                  </Text>
                  <Text color={textColor} fontSize={16} opacity={0.75}>
                    {' - '}
                  </Text>
                  <Text color={textColor} fontSize={16} fontWeight={700}>
                    {log.shiftEndTime}{' '}
                  </Text>
                </Pane>
              </Pane>
            );
          })
        ) : (
          <Pane height="50%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Paragraph color="#F0F0F2">No offers found, please check again later...</Paragraph>
          </Pane>
        ))}
      <Support iconStyle={{ position: 'absolute', right: 0, bottom: 0 }} />
    </Pane>
  );
};

export default Logs;
